import type { SVGProps } from 'react'

export const SvgCar = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 40 40"
    fill="none"
    stroke="currentColor"
    strokeWidth={3.33333}
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden
    {...props}
  >
    <path d="M31.6668 28.3334H35.0002C36.0002 28.3334 36.6668 27.6667 36.6668 26.6667V21.6667C36.6668 20.1667 35.5002 18.8334 34.1668 18.5C31.1668 17.6667 26.6668 16.6667 26.6668 16.6667C26.6668 16.6667 24.5002 14.3334 23.0002 12.8334C22.1668 12.1667 21.1668 11.6667 20.0002 11.6667H8.3335C7.3335 11.6667 6.50016 12.3334 6.00016 13.1667L3.66683 18C3.44613 18.6437 3.3335 19.3195 3.3335 20V26.6667C3.3335 27.6667 4.00016 28.3334 5.00016 28.3334H8.3335" />
    <path d="M11.6668 31.6667C13.5078 31.6667 15.0002 30.1743 15.0002 28.3333C15.0002 26.4924 13.5078 25 11.6668 25C9.82588 25 8.3335 26.4924 8.3335 28.3333C8.3335 30.1743 9.82588 31.6667 11.6668 31.6667Z" />
    <path d="M15 28.3333H25" />
    <path d="M28.3333 31.6667C30.1743 31.6667 31.6667 30.1743 31.6667 28.3333C31.6667 26.4924 30.1743 25 28.3333 25C26.4924 25 25 26.4924 25 28.3333C25 30.1743 26.4924 31.6667 28.3333 31.6667Z" />
  </svg>
)
